import { useTranslation } from 'react-i18next';

export default function ResourcesSection() {
  const { t } = useTranslation();

  const resources = [
    { icon: 'ri-table-line', title: t('resource1Title'), desc: t('resource1Desc') },
    { icon: 'ri-store-line', title: t('resource2Title'), desc: t('resource2Desc') },
    { icon: 'ri-search-eye-line', title: t('resource3Title'), desc: t('resource3Desc') },
    { icon: 'ri-truck-line', title: t('resource4Title'), desc: t('resource4Desc') },
    { icon: 'ri-box-3-line', title: t('resource5Title'), desc: t('resource5Desc') },
    { icon: 'ri-star-line', title: t('resource6Title'), desc: t('resource6Desc') },
  ];

  return (
    <section id="resources" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl font-heading">{t('resourcesTitle')}</h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">{t('resourcesSubtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {resources.map((r) => (
            <div
              key={r.title}
              className="group rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-secondary-300 hover:bg-secondary-50"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${r.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950 font-heading">{r.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}